<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">

                <strong>{{ $t('components.accountingLists') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton @click="add_sub_row()" size="sm" color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('buttons.addAccountingGroup') }}
                </CButton>

              </CCol>

            </CRow>

          </CCardHeader>
          <CCardBody>
            <CRow>


              <CCol col="5">
                <CRow form class="form-group">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{ $t('components.totalAccount') }}
                  </CCol>
                  <CCol sm="9">
                    <treeselect
                        v-model="selected_filter_parent"
                        :options="items_parent"
                        :normalizer="normalizer_filter_item"
                    />
                  </CCol>
                </CRow>
              </CCol>

              <CCol col="5">
                <CRow form class="form-group">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{ $t('components.moenAccount') }}
                  </CCol>
                  <CCol sm="9">
                    <treeselect
                        v-model="selected_filter_child"
                        :options="items_child"
                        :normalizer="normalizer_filter_item"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CDataTable
                :items="data_filtered"
                :fields="fields"
                :clickableRows="true"
                :items-per-page="20"
                hover
                sorter
                column-filter
                pagination
                @row-clicked="table_row_clicked"
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>

              <template #type="{item}">

                <td>
                  <p v-if="item.type != 'undefined'">{{ item.type }}</p>

                </td>

              </template>
              <template #vatRate="{item}">

                <td>
                  <p v-if="item.vatRate != 'undefined'">{{ item.vatRate }}</p>

                </td>

              </template>
              <template #balance="{item}">

                <td>
                  <p v-if="item.status != 'undefined'">{{ item.vat }}</p>

                </td>

              </template>
              <template #vat="{item}">

                <td>
                  <p v-if="item.status != 'undefined'">{{ item.vat }}</p>

                </td>

              </template>
              <template #status="{item}">

                <td>
                  <p v-if="item.status != 'undefined'">{{ item.status }}</p>

                </td>

              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>

    <CModal
        :show.sync="addGroupModal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        :show_footer="false"
        :title="$t('buttons.addAccountingGroup')"
    >

      <CRow>

        <CCol col="12">

          <CRow class="form-group form-row">
            <CCol col="3" style="text-align: end">
              <label></label>
            </CCol>
            <CCol col="9">
              <label>{{ selected_node_parents }}</label>
            </CCol>
          </CRow>
          <CInput
              :label="$t('components.groupName')"
              horizontal

              v-model="group_name"
          />

          <CRow class="form-group form-row">
            <CCol col="3" style="text-align: end">
              <label>{{ $t('components.visibility') }}</label>
            </CCol>
            <CCol col="9">
              <CInputCheckbox
                  :checked.sync="edit_group_visibility"
              />
              <CSwitch
                  v-bind="edit_group_visibility"

                  :value="color"
              />
            </CCol>
          </CRow>


        </CCol>
      </CRow>
      <CRow >
        <CCol style="    text-align: end;">
          <CButton @click="insert_data()" class="m-1"
                   color="secondary"
          >{{ $t("buttons.ok") }}
          </CButton>
          <CButton class="m-1"
                   @click="addGroupModal = false,status_form= 0"
                   color="secondary"
          >{{ $t("buttons.cancel") }}
          </CButton>
        </CCol>
      </CRow>

      <template #footer>

        <!--        <CButton-->
        <!--            @click="addGroupModal = false,status_form= 0"-->
        <!--            color="danger"-->
        <!--        >{{ $t("buttons.cancel") }}-->
        <!--        </CButton>-->
      </template>

      <template #footer-wrapper style="display: none">

        <label
            @click="addGroupModal = false,status_form= 0"
            color="danger"
        >
        </label>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {

    return {
      addGroupModal: false,
      group_code: '',
      group_name: '',
      group_vat: '',
      group_nature: '',
      group_type: '',
      group_parent: 0,
      items_types: [],
      color: '',
      items_natures: [],
      items_parent: [],
      selected_filter_parent: 0,
      items_child: [],
      selected_filter_child: null,
      data_with_children: [],
      data_filtered: [],
      data: [],
      fields: [
        {key: 'accountCode', label: this.$t('tables.code'), _style: 'width:2%'},
        {key: 'accountName', label: this.$t('tables.name'), _style: 'width:10%'},
        // {key: 'nature', label: this.$t('tables.nature'), _style: 'width:10%'},
        // {key: 'type', label: this.$t('tables.type'), _style: 'width:10%'},
        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:3%'},
        {key: 'vat', label: this.$t('tables.tax'), _style: 'width:3%'},
        {key: 'status', label: this.$t('tables.status'), _style: 'width:3%'},
        {key: 'status', label: 'حق جو', _style: 'width:20%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],


      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      file: '',

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,

      edit_group_name: '',
      edit_group_nature: 0,
      edit_refer_person: null,
      edit_group_code: '',
      selected_template: 0,
      selected_node_parents: '',
      table_clicks: 0,
      table_clicks_timer: null,
      status_form: 0,
      edit_group_visibility: false,
      normalizer_persons(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,

        }
      },
      normalizer_filter_item(node) {
        return {
          id: node.value,
          label: node.label,
          children: node.children,

        }
      },
    }
  }, mounted() {

    this.$root.root_validate_errors = [];


    this.get_all_docs();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    'selected_filter_parent': function () {
      this.selected_filter_child = 0;
      this.filter_data();


    }, 'selected_filter_child': function () {
      this.filter_data();

      var objects = this.get_parent(this.selected_filter_child).reverse();
      for (var i = 0; i < objects.length; i++) {
        this.selected_node_parents += " - " + objects[i]
      }
    },
    'group_nature': function () {
      this.filter_data();


    },
    'group_type': function () {
      this.filter_data();


    },

    'refer_person': function () {
      var objects = this.get_parent(this.refer_person).reverse();
      for (var i = 0; i < objects.length; i++) {
        this.selected_node_parents += " - " + objects[i]
      }
    }
  },
  methods: {

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        console.log('dblclick' + JSON.stringify(item));
        // this.addGroupModal = true
        var name = item.accountName.replaceAll("/", "|");
        this.$router.push({path: 'accounting-page/' + name})
        // this.group_nature = item.accNature
        // this.refer_person = item.id
        // this.table_clicks = 0;
        // this.status_form = item.id
        // this.edit_group_name = item.accountName
        // this.edit_group_nature = item.accNature
        // this.edit_refer_person = item.parentId
        // this.edit_group_code = item.accountCode
      }

    },
    get_parent(itemParentId) {
// if(itemParentId !=0){
      var parents = [];
      this.data.forEach((val) => {
        if (val.id == itemParentId) {
          parents.push(val.accountName)
          this.get_parent(val.parentId).forEach((val2) => {
            parents.push(val2)

          });
        }
      });
      return parents;

// }
    },
    get_all_docs() {

      this.get_lists_types();
      // this.get_lists_pay();

    },
    add_sub_row() {
      if (this.selected_filter_child != 0 && this.selected_filter_child != null) {
        this.addGroupModal = true;

      } else {
        this.$root.modal_component.show_danger_modal(this.$t('dialogs.error'), this.$t('selectMoeinDialog'));

      }
    },
    go_to_detailed(item) {

      this.$router.push({path: '/dashboard/accounting/detailed-accounting-groups/' + item.id});

    },
    filter_data() {
      console.log("filter data",this.selected_filter_parent,this.selected_filter_child)
      var self = this;
      this.data_filtered = [];
      // this.data_filtered = this.data;
      if (this.selected_filter_parent == 0) {
        this.items_child = [];
        var obj = {label: 'select', value: 0}
        this.items_child.push(obj)
        this.data.forEach((val) => {
          if (val.parentId != 0) {

            self.get_childrens_one_sub_table(val.id, self.data).forEach((val2) => {
              self.get_childrens_one_sub_table(val2.id, self.data).forEach((val3) => {
                // self.get_childrens_one_sub(val3.id, self.data).forEach((val4) => {
if(self.selected_filter_child!=0 && val3.parentId==self.selected_filter_child){
  this.data_filtered.push(val3);

}else if(self.selected_filter_child==0 || self.selected_filter_child==null ){
  this.data_filtered.push(val3);

}

                });
              // });
            });
            self.get_childrens_one_sub(val.id, self.data).forEach((val10) => {

              this.items_child.push(val10);
            });

          }

        });


      } else {
        var filtering = []
        this.data.forEach((val) => {
          if (val.parentId == self.selected_filter_parent) {

            self.get_childrens_row(val.id, self.data).forEach((val4) => {
              if (self.selected_filter_child == 0) {
                filtering.push(val4)

              } else {
                if (val4.parentId == self.selected_filter_child) {
                  filtering.push(val4)

                }
              }
            });
          }

        });

        filtering.forEach((val5) => {
          // if(val5.)
          var checked = true;
          if (this.group_type != 0 && val5.accType != this.group_type) {
            checked = false;
          }
          if (this.group_nature != 0 && val5.accNature != this.group_nature) {
            checked = false;
          }
          if (checked) {
            self.data_filtered.push(val5)

          }


        });
        this.items_child = [];
          // this.data.forEach((val) => {
          var obj = {label: 'select', value: 0}
          this.items_child.push(obj)
          // if (val.id == self.selected_filter_parent) {
          self.get_childrens_one_sub(self.selected_filter_parent, self.data).forEach((val) => {

            this.items_child.push(val);
          });

      }

    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      self.data_with_children = []
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              // self.items_receive = content_data.data.map((item, row_id) => {
              //   return {...item, row_id}
              //
              // });

              response.data.data.forEach((val) => {
                if (val.accNature == 1) {
                  val.nature = self.$t('debtor');
                }
                if (val.accNature == 2) {
                  val.nature = self.$t('creditor');
                }
                if (val.accNature == 3) {
                  val.nature = self.$t('neutral');
                }
                if (val.accNature == 0) {
                  val.nature = '';
                }

                if (val.accType == 1) {
                  val.type = self.$t('permanent');
                }
                if (val.accType == 2) {
                  val.type = self.$t('temporary');
                }
                if (val.accType == 0) {
                  val.type = '';
                }
              });
              // self.data=response.data.data;
              // self.data_filtered = response.data.data.map((item, row_id) => {
              //   return {...item, row_id}
              // })

              self.data = response.data.data.map((item, row_id) => {
                return {...item, row_id}
              })
              self.data.forEach((val5) => {
                if (val5.parentId != 0) {
                  self.data_filtered.push(val5);

                }

              });
              var obj2 = {
                label: "All",
                value: 0,
              }
              self.items_parent.push(obj2)

              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  var obj = {
                    name: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    parentId: val.parentId,
                    id: val.id,
                    children: self.get_childrens(val.id, response.data.data)


                  }
                  self.get_childrens_one_sub(val.id, self.data).forEach((val2) => {
                    var obj2 = {
                      label: val2.label,
                      code: val2.accountCode,
                      value: val2.value,
                    }
                    self.items_parent.push(obj2)

                  });
                  self.data_with_children.push(obj);


                }

              });
              self.filter_data()
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            name: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode, id: val2.id, children: this.get_childrens(val2.id, list), nature: val2.nature,
            type: val2.type,
            parentId: val2.parentId,
          }
          array.push(obj);
          // val2.inserted = true;

        }
      });
      return array;
    },
    get_childrens_row(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountName,  value: val2.id}
          array.push(val2);
          self.get_childrens_row(val2.id, list).forEach((val3) => {

            // var obj = {label: val3.accountName,  value: val3.id}
            array.push(val3);
            // val2.inserted = true;
          });

        }
      });
      return array;
    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(obj);


        }
      });
      return array;
    },
    get_childrens_one_sub_table(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    get_lists_types() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_SysAccountTypes";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_types = [];
          var obj = {label: "select", value: 0};
          self.items_types.push(obj);

          response.data.data.forEach((val) => {
            var obj = {label: val.accTypeTitle, value: val.accTypeId};
            self.items_types.push(obj);

          });
          self.group_type = 0
          self.get_lists_natures();
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_natures() {
      var self = this;


      const formData = new FormData();
      var url = "Get_SysAccountNatures";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_natures = [];
          var obj = {label: "select", value: 0};
          self.items_natures.push(obj);

          response.data.data.forEach((val) => {
            var obj = {label: val.accNatureTitle, value: val.accNatureId};
            self.items_natures.push(obj);

          });
          self.group_nature = 0;
          self.get_lists_groups();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.group_name != '') {
        return true;
      }


      // if (this.group_code == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
      // }
      if (this.group_name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "Add_AccountingGroup";

      formData.append('AccountId', this.status_form)

      formData.append('AccountName', this.group_name);
      formData.append('AccountCode', this.group_code);
      formData.append('AccType', this.group_type);
      formData.append('AccNature', this.group_nature);
      formData.append('ParentId', this.group_parent);
      self.addGroupModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.status_form = 0;
        self.group_parent = 0;
        self.group_name = '';
        self.group_code = '';
        self.get_all_docs();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  },

}

</script>
<style>
.zk-table__cell-inner {
  text-align: initial;
}
</style>